import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { loadSyncUp, loadStreakData } from '../../../redux';
import s from './GamesBudgetCta.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import { TOI_LIVE_DOMAIN } from '../../../../../constants';

const GamesBudgetCta = props => {
  // eslint-disable-next-line no-unused-vars
  const { userData, streakData, gameId, gameType, ga4Category } = props;

  const openShareBoxClick = () => {
    const url = `${TOI_LIVE_DOMAIN}/business/budget`;
    window.open(url, '_blank');
  };
  return (
    <div className={`${s.widgetWrap}`}>
      <InViewObserver
        inViewCallback={() => {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'streak_widget',
            category: ga4Category || '',
            label: 'login_to_begin_a_streak',
          });
        }}
      >
        <div className={s.widgetContent}>
          <figure>
            <img
              src="https://static.toiimg.com/photo/117629414.cms"
              alt="budget pro"
            />
          </figure>
          <div className={s.widgetText}>
            <strong>You are a Budget Pro</strong>
            <p>
              Loved the Budget crossword? Dive deeper into the latest Budget
              news and updates
            </p>
          </div>
          <button
            className={`${s.shadowBtn}`}
            onClick={() => {
              openShareBoxClick();
              analyticsWrapper('ga4', {
                event: 'user_click',
                type: 'streak_widget',
                category: ga4Category || '',
                label: 'login_to_begin_a_streak',
              });
            }}
          >
            Explore Now
          </button>
        </div>
      </InViewObserver>
    </div>
  );
};

GamesBudgetCta.propTypes = {
  gameId: PropTypes.string,
  gameType: PropTypes.string,
};

GamesBudgetCta.defaultProps = {
  gameId: '',
  gameType: 'crossword',
};

const mapStateToProps = state => ({
  streakData: state.toigames && state.toigames.streak,
  userData: state.login.userData,
});

const mapDispatchToProps = dispatch => ({
  loadStreakData: params => {
    dispatch(loadStreakData(params));
  },
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GamesBudgetCta);
